import React from "react";
import "./style.css";

const LogicalTopologyPage: React.FC = () => {
  // style={{ textAlign: 'center', marginLeft: '-2rem' }}
  // const height = 900
  // const width = height * 1.42

  return (
    <div className="container">
      <img
        className="logical-map"
        src={process.env.PUBLIC_URL + "/stp_topology.svg"}
        alt="Mapa de Topología Lógica"
        // width={width}
        // height={height}
      />
    </div>
  );
};
export default LogicalTopologyPage;
